module.exports = __webpack_public_path__ + "img/Panna.ba234c82.jpg";